<template>
  <div class="stu-care-archives-record">
    <div style="display: flex; align-items: center; margin: 20px 0">
      <span class="title" style="margin-right: 10px">学生关爱档案记录</span>
      <j-dict-select-tag
        placeholder="请选择档案记录类型"
        v-model="careRecordType"
        style="width: 200px"
        dictCode="archives_record_type"
      />
      <a-button type="primary" style="margin-left: 10px" @click="changeCareRecordType">
        查询
      </a-button>
      <!-- 导出按钮 -->
      <a-button
        :disabled="!showExportBtn"
        icon="download"
        iconPosition="right"
        style="margin-left: 10px"
        :loading="exportLoading"
        @click="exportData"
      >
        导出
      </a-button>
    </div>
    <a-spin :spinning="loading">
      <a-timeline v-if="timelineRecord.length">
        <a-timeline-item v-for="item in timelineRecord" :key="item.id">
          <div class="timeline-title">
            {{ item.date }}
            <span>{{ item.title }}</span>
          </div>
          <div v-show="item.dataType == 20" class="card-box">
            <div class="card-title">
              <div class="timeline-title">{{ item.name }}</div>
              <a-button type="primary" @click="viewReport(item)">查看详细报告</a-button>
            </div>
            <div class="eval-box">
              <RadarChart
                height="250px"
                :chartStyle="{ width: '30%' }"
                radius="75"
                :tooltip="{ position: 'top' }"
                :fields="item.chartData?.legend"
                :indicator="item.chartData?.indicator"
                :dataSource="item.chartData?.data"
              />
              <div class="suggestion box-shadow-1">
                <div v-for="(pItem, index) in item.pointScoreList" :key="index">
                  <div class="title" style="margin: 5px 0">{{ pItem.pointName }}</div>
                  <div>{{ pItem.suggestion }}</div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="item.dataType == 1"
            v-for="(innerList, index) in item.cardList"
            :key="index"
            class="card-box"
          >
            <div v-for="card in innerList" :key="card.key" class="card-item">
              <span class="card-key">{{ card.key }}：</span>
              <!-- <span v-html="card.value || '无'" class="card-value"></span> -->
              <template v-if="card.type === 'image'">
                <div
                  v-if="card.value && (Array.isArray(card.value) ? card.value.length : card.value)"
                  style="display: flex; flex-wrap: wrap; gap: 10px; margin-top: 5px"
                >
                  <template
                    v-for="(file, fileIdx) in (Array.isArray(card.value)
                      ? card.value
                      : card.value.split(',')
                    ).filter((i) => i)"
                  >
                    <img
                      v-if="isImage(file)"
                      :key="fileIdx"
                      :src="getImgView(file)"
                      @click="showImgDialog(getImgView(file))"
                      style="
                        width: 80px;
                        height: 80px;
                        object-fit: cover;
                        border-radius: 4px;
                        cursor: pointer;
                        border: 1px solid #eee;
                      "
                    />
                    <div
                      v-else
                      :key="fileIdx"
                      class="file-attachment"
                      @click="handleFileClick(file)"
                    >
                      <a-icon type="paper-clip" />
                      <span>附件{{ fileIdx + 1 }}</span>
                    </div>
                  </template>
                </div>
                <span v-else>无</span>
              </template>
              <span v-else v-html="card.value || '无'" class="card-value"></span>
            </div>
            <div v-show="item.file" style="margin-top: 5px; color: #1783e8">
              <span>{{ item.title }}附件</span>
              <span class="download-btn" @click="downloadFile(item)">下载</span>
            </div>
          </div>

          <div v-show="item.dataType != 20 && item.dataType != 1" class="card-box">
            <div v-for="card in item.cardList" :key="card.key" class="card-item">
              <span class="card-key">{{ card.key }}：</span>
              <template v-if="card.type === 'image'">
                <div
                  v-if="card.value && (Array.isArray(card.value) ? card.value.length : card.value)"
                  style="display: flex; flex-wrap: wrap; gap: 10px; margin-top: 5px"
                >
                  <template
                    v-for="(file, fileIdx) in (Array.isArray(card.value)
                      ? card.value
                      : card.value.split(',')
                    ).filter((i) => i)"
                  >
                    <img
                      v-if="isImage(file)"
                      :key="fileIdx"
                      :src="getImgView(file)"
                      @click="showImgDialog(getImgView(file))"
                      style="
                        width: 80px;
                        height: 80px;
                        object-fit: cover;
                        border-radius: 4px;
                        cursor: pointer;
                        border: 1px solid #eee;
                      "
                    />
                    <div
                      v-else
                      :key="fileIdx"
                      class="file-attachment"
                      @click="handleFileClick(file)"
                    >
                      <a-icon type="paper-clip" />
                      <span>附件{{ fileIdx + 1 }}</span>
                    </div>
                  </template>
                </div>
                <span v-else>无</span>
              </template>
              <span v-else v-html="card.value || '无'" class="card-value"></span>
            </div>
            <div v-show="item.file" style="margin-top: 5px; color: #1783e8">
              <span>{{ item.title }}附件</span>
              <span class="download-btn" @click="downloadFile(item)">下载</span>
            </div>
          </div>
        </a-timeline-item>
      </a-timeline>
      <EmptyData v-else :styleObj="{ padding: '30px 0' }" :loading="loading" />
    </a-spin>
    <DetailedReport ref="detailedReportRef" />

    <a-modal
      hoverable
      title="查看照片"
      :visible="imgboxModal"
      centered
      @cancel="() => ((imgModelSrc = ''), (imgboxModal = false))"
      width="50%"
      :footer="null"
    >
      <img :src="imgModelSrc" alt style="width: 100%" />
    </a-modal>
  </div>
</template>
<script>
import RadarChart from '@/components/echartZyz/components/RadarChart'
import DetailedReport from '@/comUi/ArchivesView/components/DetailedReport.vue'
import JMultiSelectTag from '@comp/dict/JMultiSelectTag.vue'
import { downloadFile } from '@/utils/util'
import { getFileAccessHttpUrl, downFile } from '@/api/manage'
export default {
  name: 'StuCareArchivesRecord',
  components: {
    JMultiSelectTag,
    RadarChart,
    DetailedReport,
  },
  props: {
    timeline: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    stuInitInfo: {
      type: Object,
      default: () => {},
    },
    beginDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    // 是否显示导出按钮（仅当选择了辅导记录8,家访记录 50、关爱记录 60 或 时显示）
    showExportBtn() {
      const EXPORTABLE_TYPES = ['1', '8', '60', '70']
      // 1. 判空处理 2. 使用正则或 includes 快速匹配，避免频繁 split 产生临时数组
      return EXPORTABLE_TYPES.some((type) => this.careRecordType?.includes(type))
    },
  },
  data() {
    return {
      careRecordType: undefined,
      timelineRecord: [],
      fields: [],
      indicator: [],
      imgboxModal: false,
      imgModelSrc: '',
      exportLoading: false,
    }
  },
  watch: {
    timeline: {
      handler(val) {
        // console.log('时间轴信息：', val)
        this.getCareRecordList(val)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /* 图片预览 */
    getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','))
      }
      return getFileAccessHttpUrl(text)
    },
    viewReport(data) {
      this.$refs.detailedReportRef.showModal(data)
    },
    changeCareRecordType() {
      console.log('关爱学生档案记录：', this.careRecordType)
      this.$emit('refreshData', this.careRecordType && { recordTypes: this.careRecordType })
    },
    showImgDialog(src) {
      this.imgboxModal = true
      this.imgModelSrc = src
    },
    getCareRecordList(arr) {
      this.timelineRecord = []
      arr.forEach((item) => {
        let obj = {
          date: item.date,
          title: item.title,
          file: item.file,
          dataType: item.dataType,
        }
        // dataType
        // 0 - 心情记录
        // 1 - 提醒记录
        // 4 - 心理评估
        // 5 - 危机干预学生咨询
        // 6 - 危机干预班主任沟通
        // 7 - 危机干预家校互动
        // 8 - 辅导台账
        // 20 - 评测记录
        // 30 - 事件记录
        // 50 - 辅导记录
        // 60 - 家访记录

        switch (String(item.dataType)) {
          case '0':
            obj.cardList = [
              {
                key: '原因分析',
                value: item.tags,
              },
              {
                key: '备注',
                value: item.comment,
              },
            ]
            break
          case '1':
            obj.cardList = []
            var discussList = item.discussList
            discussList.forEach((discussListItem) => {
              let discussListDetail = []
              const comment = discussListItem.comment || ''
              if (comment.includes('已跟进处理')) {
                discussListDetail = [
                  {
                    key: '处理时间',
                    value: discussListItem.createTime,
                  },
                  { key: '记录老师', value: discussListItem.name },
                  { key: '处理状态', value: comment },
                  {
                    key: '关爱时间',
                    value: discussListItem.careTime,
                  },
                  {
                    key: '问题原因',
                    value: discussListItem.warningReason,
                  },
                  {
                    key: '干预措施',
                    value: discussListItem.intervention,
                  },
                  {
                    key: '效果反馈',
                    value: discussListItem.effectFeedback,
                  },
                  // {
                  //   key: '以上信息是否反馈校领导',
                  //   value:
                  //     discussListItem.feedbackFlag === 1 ? '是' + discussListItem.leaderName : '否',
                  // },
                  {
                    key: '班主任沟通记录表',
                    value: discussListItem.attachUrls ? discussListItem.attachUrls.split(',') : [],
                    type: 'image',
                  },
                  {
                    key: '具体情况说明',
                    value: discussListItem.remark ? discussListItem.remark : '',
                  },
                ]
              } else if (comment.includes('已预约心理老师')) {
                discussListDetail = [
                  { key: '处理时间', value: discussListItem.createTime },
                  { key: '处理状态', value: comment },
                  { key: '记录老师', value: discussListItem.name },
                  {
                    key: '具体情况说明',
                    value: discussListItem.remark ? discussListItem.remark : '',
                  },
                ]
              } else if (comment.includes('心理老师已确认预约')) {
                discussListDetail = [
                  { key: '处理时间', value: discussListItem.createTime },
                  { key: '处理状态', value: comment },
                  { key: '确认人', value: discussListItem.name },
                ]
              } else if (comment.includes('已辅导完成')) {
                discussListDetail = [
                  { key: '处理时间', value: discussListItem.createTime },
                  { key: '处理状态', value: comment },
                  { key: '记录老师', value: discussListItem.name },
                  {
                    key: '辅导时间',
                    value: discussListItem.careTime
                      ? discussListItem.careTime.substring(0, 10)
                      : '',
                  },
                  { key: '辅导类型', value: discussListItem.tutoringType },
                  { key: '辅导方法', value: discussListItem.tutoringMethod },
                  { key: '问题原因', value: discussListItem.psychologyIssues },
                  // { key: '干预措施', value: discussListItem.intervention },
                  { key: '下一步措施', value: discussListItem.nextIntervention },
                  { key: '效果反馈', value: discussListItem.effectFeedback },
                  { key: '危机等级', value: discussListItem.crisisLevel },
                  {
                    key: '以上信息是否反馈校领导',
                    value:
                      discussListItem.feedbackFlag === 1 ? '是' + discussListItem.leaderName : '否',
                  },
                  {
                    key: '辅导记录表',
                    value: discussListItem.attachUrls ? discussListItem.attachUrls.split(',') : [],
                    type: 'image',
                  },
                  {
                    key: '具体情况说明',
                    value: discussListItem.remark ? discussListItem.remark : '',
                  },
                ]
              } else if (comment.includes('已上报')) {
                discussListDetail = [
                  { key: '上报时间', value: discussListItem.createTime },
                  { key: '处理状态', value: comment },
                  { key: '上报人', value: discussListItem.name },
                  {
                    key: '具体情况说明',
                    value: discussListItem.remark ? discussListItem.remark : '',
                  },
                ]
              } else {
                discussListDetail = [
                  { key: '处理时间', value: discussListItem.createTime },
                  { key: '操作人', value: discussListItem.name },
                  { key: '处理内容', value: comment },
                ]
              }
              obj.cardList.push(discussListDetail)
            })
            break
          case '4':
            obj.cardList = [
              { key: '问题原因', value: item.tag },
              { key: '关爱等级', value: item.careList },
              { key: '备注', value: item.comment },
            ]
            break
          case '5':
          case '6':
          case '7':
            obj.cardList = [
              { key: '问题原因', value: item.tag },
              { key: '干预措施', value: item.intervention },
              { key: '效果反馈', value: item.effectFeedback },
              { key: '关爱等级', value: item.careList },
              { key: '家校互动老师', value: '' },
              { key: '具体情况说明', value: item.comment },
            ]
            break
          case '8':
            // obj.cardList = [
            //   {
            //     key: '辅导类型',
            //     value: item.tutoringType,
            //   },
            //   {
            //     key: '问题原因',
            //     value: item.tag,
            //   },
            //   { key: '效果反馈', value: item.effectFeedback },
            //   { key: '关爱等级', value: item.careList },
            //   { key: '沟通老师', value: item.name },
            //   {
            //     key: '具体情况说明',
            //     value: item.comment,
            //   },
            // ]
            obj.cardList = [
              {
                key: '记录时间',
                value: item.date,
              },
              {
                key: '记录老师',
                value: item.teacherName,
              },
              {
                key: '辅导时间',
                value: item.tutoringTime,
              },
              { key: '辅导类型', value: item.tutoringType },
              { key: '辅导方法', value: item.tutoringMethod },
              { key: '问题原因', value: item.reason },
              // { key: '干预措施', value: item.interventionId },
              { key: '下一步措施', value: item.nextIntervention },
              { key: '效果反馈', value: item.effectFeedback },
              { key: '危机等级', value: item.crisisLevel },
              {
                key: '是否反馈校领导',
                value: item.feedbackFlag == 1 ? '是&nbsp;&nbsp;' + item.leaderName : '否',
              },
              {
                key: '辅导记录表',
                value: item.tutorRecordUrl
                  ? Array.isArray(item.tutorRecordUrl)
                    ? item.tutorRecordUrl
                    : item.tutorRecordUrl.split(',')
                  : [],
                type: 'image',
              },
              {
                key: '具体情况说明',
                value: item.specificInstructions,
              },
            ]
            break
          case '30':
            obj.cardList = [
              {
                key: '事件类型',
                value: item.events_type,
              },
              {
                key: '事件内容',
                value: item.comment,
              },
            ]
            break
          case '50':
            obj.cardList = [
              {
                key: '记录时间',
                value: item.date,
              },
              {
                key: '记录老师',
                value: item.teacherName,
              },
              {
                key: '辅导时间',
                value: item.tutoringTime,
              },
              { key: '辅导类型', value: item.tutoringType },
              { key: '辅导方法', value: item.tutoringMethod },
              { key: '问题原因', value: item.reason },
              // { key: '干预措施', value: item.interventionId_dictText },
              { key: '下一步措施', value: item.nextIntervention },
              { key: '效果反馈', value: item.effectFeedback_dictText },
              { key: '关爱等级', value: item.crisisLevel },
              {
                key: '是否反馈校领导',
                value: item.feedbackFlag == 1 ? '是&nbsp;&nbsp;' + item.leaderName : '否',
              },
              {
                key: '辅导记录表',
                value: item.tutorRecordUrl
                  ? Array.isArray(item.tutorRecordUrl)
                    ? item.tutorRecordUrl
                    : item.tutorRecordUrl.split(',')
                  : [],
                type: 'image',
              },
              {
                key: '具体情况说明',
                value: item.specificInstructions,
              },
            ]
            break
          case '60':
            obj.cardList = [
              { key: '记录时间', value: item.date },
              { key: '记录老师', value: item.teacherName },
              { key: '家访时间', value: item.visitTime },
              { key: '家访目录', value: item.visitIntent },
              {
                key: '家庭情况',
                value:
                  '家庭结构：' +
                  (item.structure_dictText || '无') +
                  '<br>家庭经济情况：' +
                  (item.financialSituation_dictText || '无') +
                  '<br>家庭氛围：' +
                  (item.atmosphere_dictText || '无') +
                  '<br>亲子关系：' +
                  (item.childRelationship_dictText || '无') +
                  '<br>学生健康情况：' +
                  (item.healthCondition || '无'),
              },
              {
                key: '学业情况',
                value:
                  '成绩情况：' +
                  (item.performanceStatus_dictText || '无') +
                  '<br>上课情况：' +
                  (item.classAttendance_dictText || '无') +
                  '<br>作业完成情况：' +
                  (item.homeworkCompletionStatus_dictText || '无'),
              },
              // { key: '同伴关系', value: item.peerRelationship },
              // { key: '亲子关系', value: item.parentChildRelationship },
              { key: '家长配合度', value: item.parentalCooperation },
              { key: '应对措施', value: item.responseMeasures },
              {
                key: '家访照片',
                value: item.fileUrl
                  ? Array.isArray(item.fileUrl)
                    ? item.fileUrl
                    : item.fileUrl.split(',')
                  : [],
                type: 'image',
              },
              { key: '综合评价', value: item.comprehensiveEvaluation },
            ]
            break
          case '70':
            obj.cardList = [
              { key: '关爱时间', value: item.careTime },
              { key: '记录老师', value: item.teacherName },
              { key: '问题原因', value: item.psychologyIssues },
              { key: '干预措施', value: item.intervention },
              { key: '效果反馈', value: item.effectFeedback },
              {
                key: '班主任沟通记录表',
                value: item.attachUrls
                  ? Array.isArray(item.attachUrls)
                    ? item.attachUrls
                    : item.attachUrls.split(',')
                  : [],
                type: 'image',
              },
              { key: '具体情况说明', value: item.comment },
            ]
            break

          default:
            break
        }
        item.dataType != 20 ? this.timelineRecord.push(obj) : this.timelineRecord.push(item)
      })
    },
    // 导出
    // exportData() {
    //   const params = {
    //     // id: this.stuInitInfo.studentId,
    //     // beginDate: this.beginDate,
    //     // endDate: this.endDate,
    //     // ...this.queryParam,
    //   }
    //   getAction('/aigoes/studentInfo/exportHomeVisitRecord', params)
    // },

    exportData() {
      const name = {
        1: '提醒记录',
        8: '辅导台账',
        60: '家访记录',
        70: '自主关爱记录',
      }
      console.log('name--------------', this.stuInitInfo)

      const fileName = `${this.stuInitInfo.studentName || '学生'}${name[this.careRecordType]}`
      let param = {
        studentId: this.stuInitInfo.studentId,
        beginDate: this.beginDate,
        endDate: this.endDate,
        recordTypes: this.careRecordType,
      }
      this.exportLoading = true
      // 自主关爱档案记录
      downFile('/aigoes/studentInfo/exportStudentCareRecord', param)
        .then((data) => {
          if (!data) {
            this.$message.warning('文件下载失败')
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], { type: 'application/vnd.ms-excel' }),
              fileName + '.xls'
            )
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: 'application/vnd.ms-excel' })
            )
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName + '.docx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link) // 下载完成移除元素
            window.URL.revokeObjectURL(url) // 释放掉blob对象
          }
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    downloadFile(item) {
      downloadFile(item.file, item.title + '附件')
    },
    isImage(url) {
      if (!url) return false
      const imgExts = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp']
      const lowerUrl = url.toLowerCase()
      return imgExts.some((ext) => lowerUrl.endsWith(ext))
    },
    handleFileClick(url) {
      if (!url) return
      const fullUrl = getFileAccessHttpUrl(url)
      window.open(fullUrl)
    },
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 18px;
  font-weight: bold;
}

.timeline-title {
  padding-bottom: 10px;
  font-size: 15px;
  font-weight: bold;
}

.eval-box {
  display: flex;
  //   align-items: center;
  .content {
    line-height: 2;
  }

  .suggestion {
    flex: 1;
    height: 230px;
    padding: 10px;
    margin-left: 15px;
    border-radius: 5px;
    overflow-y: auto;
  }
}

.card-box {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 10px;
  font-size: 13px;
  line-height: 2;

  .card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .card-key {
    font-weight: bold;
  }

  .card-item {
    display: flex;
  }
}

.download-btn {
  display: inline-block;
  padding: 1px 14px;
  margin-left: 10px;
  border: 1px solid #1783e8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.file-attachment {
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 80px;
  background: #f5f5f5;
  border: 1px solid #eee;
  border-radius: 4px;
  cursor: pointer;
  color: #1783e8;
  transition: all 0.3s;

  &:hover {
    background: #e6f7ff;
    border-color: #1783e8;
  }

  i {
    font-size: 16px;
    margin-right: 4px;
  }
}
</style>
